import { render, staticRenderFns } from "./AdminDropdownView.vue?vue&type=template&id=c175aef6"
import script from "./AdminDropdownView.vue?vue&type=script&lang=js"
export * from "./AdminDropdownView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports